import KeyResultBinaryChoice from "@/constants/KeyResultBinaryChoice";

const KeyResultMeasurement = Object.freeze( {
	BINARY: "BINARY",
	PERCENTAGE: "PERCENTAGE",
	CURRENCY: "CURRENCY",
	NUMERIC: "NUMERIC",
} );

export default KeyResultMeasurement;

export const defaultValues = {
	[ KeyResultMeasurement.BINARY ]: () => ( {
		currentValue: KeyResultBinaryChoice.INCOMPLETE,
		goalValue: KeyResultBinaryChoice.COMPLETE,
	} ),
	[ KeyResultMeasurement.PERCENTAGE ]: () => ( { currentValue: 0, goalValue: 100, } ),
	[ KeyResultMeasurement.CURRENCY ]: () => ( { currentValue: 0, goalValue: "", } ),
	[ KeyResultMeasurement.NUMERIC ]: () => ( { currentValue: 0, goalValue: "", } ),
	default: () => ( { currentValue: "", goalValue: "", } ),
};



// WEBPACK FOOTER //
// ./src/constants/KeyResultMeasurement.js